// extracted by mini-css-extract-plugin
module.exports = {"switch":"ToggleSwitch_switch__1dhpd","slider":"ToggleSwitch_slider__28RGy"};